import { render, staticRenderFns } from "./CoreAddress.html?vue&type=template&id=4125872c&external"
import script from "./CoreAddress.vue?vue&type=script&lang=js"
export * from "./CoreAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports